import { motion, useAnimation, useInView } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import JumpingLetters from "../JumpingLetters";
import TypingLetters from "../TypingLetters";
import { getCDNUrl } from "../Cloudinary";

const thumbnailVariants = {
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut"
        }
    },
    hidden: {
        opacity: 0,
        y: 50
    },
}

const overlayVariants = {
    visible: {
        opacity: 1,
    },
    hidden: {
        opacity: 0,
    },
}


function Thumbnail({ alt, image, page, name}) {
    const controls = useAnimation();
    const ref = useRef(null);
    const inView = useInView(ref);
    const navigate = useNavigate();

    useEffect(()=> {
        if(inView) { 
            controls.start("visible");
        }
    }, [controls, inView])

    const handleClick = () => {
        navigate(`/graphicDesign/${page}`);
    }

    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={thumbnailVariants}
            onClick={handleClick}
            whileHover={{
                scale: 1.02,
            }}
            style={{
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",

            }}
        >
            <img src={image} alt={alt} loading="lazy" />
            <motion.div 
                variants={overlayVariants}
                initial="hidden"
                whileHover="visible"
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    backgroundColor: "#1e1916e6",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <span 
                    style={{
                        color: "white",
                        fontSize: "clamp(1rem, 2.5vw, 2rem)",
                        padding: "25px",
                    }}
                >
                    {name}
                </span>
            </motion.div>

        </motion.div>
    );

}

export default function GraphicDesign() {
    const [isHover, setIsHover] = useState(false);
    
    return (
    <motion.div
        initial={{
            opacity: 0,
            x: -50

        }}
        animate={{
            opacity: 1,
            x: 0,
        }}
        exit={{
            opacity: 0,
            x: 50
        }}
        transition={{
            duration: 0.3,
            ease: "backInOut"
        }}
    >



        <span className="page-title-animated"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={{ display: "inline-block", cursor: "pointer" }}
        >
            <JumpingLetters text="Design" isHover={isHover}/>
        </span>
        
        <div className="page-intro-text" >
            <TypingLetters text="Explore my design projects:"/>
        </div>
        
        <section className="design-section">
        <h2>UF Sparks Magazine</h2> 
            <div className="design-grid">
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("Sp2026_Cover_thumb_fghf7m", "w_800,q_auto,f_auto")} 
                            page="cover-spring26"
                            name="Spring 2026 Cover"
                        />
                    </div>
                </div>
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("matcha-design-thumb_pzmc1i", "w_800,q_auto,f_auto")} 
                            page="matcha"
                            name="The Rise and Reinvention of Matcha"
                        />
                    </div>
                </div>
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("ink-mag-design-thumb_wfm7ei", "w_800,q_auto,f_auto")} 
                            page="ink-mag"
                            name="Stories Before the Spark: Ink Magazine"

                        />
                </div>
                </div>
                {/* <div className="design-column">
                    
                </div> */}
            </div>
        </section>

        <section className="design-section">
        <h2>Motion Design</h2> 
            <div className="design-grid">
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("candle-forest-thumb_tr3qyu", "w_800,q_auto,f_auto")} 
                            page="candle-forest"
                            name="Forest of Candles"
                        />
                    </div>
                </div>
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("circus-text-thumb_rasxzn", "w_800,q_auto,f_auto")} 
                            page="circus-text"
                            name="Marvels Await"
                        />
                    </div>
                </div>
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("coffee-ad-thumb_bdnf88", "w_800,q_auto,f_auto")} 
                            page="coffee-ad"
                            name="Coffee Ad"
                        />
                    </div>
                </div>
            </div>
        </section>

        {/* <section className="design-section">
            <h2>Web Design</h2> 
            <div className="design-grid">
                <div className="design-column">
                    <div className="design-thumbnail">
                    
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("sparks-web-design-thumb_xkzm8b", "w_800,q_auto,f_auto")} 
                            
                        />
                    </div>
                </div>
                <div className="design-column">
                    
                </div>
                <div className="design-column">
                    
                </div>
            </div>
        </section> */}

        <section className="design-section">
            <h2>Game Asset Design</h2> 
            <div className="design-grid">
                <div className="design-column">
                    <div className="design-thumbnail">
                    
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("no-laughing-matter-thumb_jqp63d", "w_800,q_auto,f_auto")} 
                            page="no-laughing-matter"
                            name="No Laughing Matter"
                        />
                    </div>
                </div>
                <div className="design-column">
                    <div className="design-thumbnail">
                    
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("Hui_A06_Title_tciedw", "w_800,q_auto,f_auto")} 
                            page="clockwork-repair"
                            name="Clockwork Repair"
                        />
                    </div>
                </div>
                <div className="design-column">
                    
                </div>
            </div>
        </section>

        <section className="design-section">
            <h2>Poster Design</h2> 
            <div className="design-grid">
                <div className="design-column">
                    <div className="design-thumbnail">
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("new-year-ad-design-thumb_ezikjb", "w_800,q_auto,f_auto")} 
                            page="lunar-new-year"
                            name="Lunar New Year Festival"
                        />
                    </div>
                </div>

                
                <div className="design-column">
                    <div className="design-thumbnail">
                        
                        <Thumbnail 
                            alt="" 
                            image={getCDNUrl("sleep-infographic-design-thumb_hp8g0h","w_800,q_auto,f_auto")} 
                            page="sleep-habits"
                            name="UF Student Sleeping Habits"
                        />
                    </div>
                    
                </div>
                <div className="design-column">
                    
                </div>
            </div>
        </section>
    </motion.div>

    );
}